<template>
    <div class="modal fade" :id="idModalRectification" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">EMBARCACION {{ nameShip }} </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="brand_engine" class="badge badge-primary">Marca Motor</label>
                                <input type="text" class="form-control" v-model="engineRectification.trademark" name="flag" placeholder="Marca Motor" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="model_engine" class="badge badge-primary">Modelo Motor</label>
                                <input type="text" class="form-control" v-model="engineRectification.model" name="model_engine" placeholder="Modelo Motor" autocomplete="off">
                            </div>                        
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="rpm_engine" class="badge badge-primary">HP por RPM</label>
                                <input type="number" class="form-control" v-model="engineRectification.rpm" name="flag" placeholder="Hp por RPM" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="serie_engine" class="badge badge-primary">Serie</label>
                                <input type="text" class="form-control" v-model="engineRectification.serie" name="model_engine" placeholder="Serie Motor" autocomplete="off">
                            </div>                    
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="combustible_construction" class="badge badge-primary">Combustible</label>
                                <select class="form-control" name="combustible_construction" v-model="engineRectification.gasoline">
                                    <option v-for="gas in typeGasolines" :value="gas.id" :key="gas.id">{{ gas.detail }}</option>
                                </select>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="engine_autonomia" class="badge badge-primary">Autonomia</label>
                                <input type="text" class="form-control" v-model="engineRectification.autonomia" name="model_engine" placeholder="Autonomia Motor" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="engine_velocity" class="badge badge-primary">Velocidad Maxima</label>
                                <input type="number" class="form-control" v-model="engineRectification.velocity_max" name="engine_velocity" placeholder="Velocidad Maxima" autocomplete="off">
                            </div>
                        </div>                                           
                            
                    </div>               
                    
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-success" @click="mValidateEngine" :disabled="btnSend" v-if="isEditable"><font-awesome-icon icon="save" size="lg" /></button>
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>
                        
                    </div>
                </div>
            </div>
            
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

const qs= require('qs');


export default {
    name:'modal-engine',
    props:{
        engineRectification:Object,
        idModalRectification:String,
        typeGasolines:Array,
        nameShip:String,
        isEditable:{
            type:Boolean,
            default:true
        },
        typeForm:{
            type:String,
            default:'rectifi'
        }
    },
    data(){
        return {
            btnSend:false
        }
    },
    methods:{
        mValidateEngine(){
            
            let v=true;
            if( !this.engineRectification.trademark){
                toastr.error('Indique la Marca', 'Error');
                v=false;
            }
            if(!this.engineRectification.model){
                toastr.error('Indique el modelo', 'Error');
                v=false;
            }
            if(!this.engineRectification.gasoline){
                toastr.error('Seleccione el combustible', 'Error');
                v=false;
            }
            
            if(!this.engineRectification.rpm){
                toastr.error('Indique su rpm', 'Error');
                v=false;
            }

            if(!this.engineRectification.serie){
                toastr.error('Indique su serie', 'Error');
                v=false;
            }

            if(!this.engineRectification.velocity_max){
                toastr.error('Indique la velocidad', 'Error');
                v=false;
            }

            if(!this.engineRectification.autonomia){
                toastr.error('Indique la autonomia', 'Error');
                v=false;
            }

            if(v){
                this.btnSend=true;
                this.mSendEngine();
            }

        },
        mSendEngine(){
            console.log('llegando al envio del nuevo motor')
            let e={
                engine:JSON.stringify(this.engineRectification)
            }
            let url='';
            // aqui ver la url
            if(this.typeForm==='rectifi'){
                // aqui la url es para rectificacion tambien la fecha de ultima revision no considerar
                url='updateEngine';
            }else{
                // debemos actualizar la tabla hacer un update y colocar en modo vencido la matricula y no considerar la fecha de actualizacion sino directamente colocar a estado vencido y colocar estado de verificacion a revisado
                url='updateEngineRenew';
            }

            toastr.info("enviando datos")
            
            // axios.post(`updateEngine`, qs.stringify(e))
            axios.post(`${url}?api_token=${Vue.auth.getToken()}`, qs.stringify(e))
                .then((res)=>{
                    console.log(res.data);
                    if(parseInt(res.data[1].id_engine)>0){
                        setTimeout(()=>{
                            toastr.success(res.data[0].respuesta)
                            // this.engineRectification.id_motor=parseInt(res.data[1].id_engine);
                            this.btnSend=false;
                            this.closeModal();
                        },2000)
                    }else{
                        toastr.error('Ha ocurrido un error al actualizar')
                    }
                    
                })
                .catch((err)=>{
                    console.error(err)
                })
        },
        closeModal(){
            console.log('presionando el boton de close');
             $(`#${this.idModalRectification}`).modal('hide')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/rectification/ModalEngine.vue